import {
  Component,
  Input,
  EventEmitter,
  Output,
  OnChanges
} from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { ModalController, NavController, NavParams } from 'ionic-angular';

@Component({
  selector: 'new-lubbu-form',
  templateUrl: 'new-lubbu-form.html'
})
export class NewLubbuFormComponent implements OnChanges {
  @Input() showOptions: boolean = true;
  @Output() formChanged = new EventEmitter();

  public item: any;
  private lubbu: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    public modalCtrl: ModalController,
    public navParams: NavParams,
    public navCtrl: NavController
  ) {
    this.item = this.navParams.get('item');

    let name = '';
    let note = '';
    let amount = '';

    if (this.item) {
      name = this.item.title;
      amount = this.item.amount;
      note = this.item.comment;
    }

    this.lubbu = this.formBuilder.group({
      name: [name, Validators.required],
      note: [note],
      amount: [amount]
    });

    // ngChanges form
    this.lubbu.valueChanges.subscribe(changes => {
      this.formChanged.emit(this.lubbu);
    });
  }

  ngOnChanges() {
    this.formChanged.emit(this.lubbu);
  }

  selectGiftCard() {
    this.navCtrl.push('AddGiftCardsPage');
  }

  searchPhoto() {
    let modal = this.modalCtrl.create('UnsplashImagePage', {});
    modal.present();
  }

  createLubbu() {}
}



// WEBPACK FOOTER //
// ./src/components/new-lubbu-form/new-lubbu-form.ts